module.exports = __webpack_public_path__ + "69bd78d57a9e45e0da6ec73793406c2a.png";